// extracted by mini-css-extract-plugin
export default {"toneBronze":"AOBgLhfX7HbBWMkJnL5i","toneGreen":"Dz3ZzJ8H6r6Mb67nu8q7","toneRed":"tcpoLjn1oTiqG8X3RRtW"};